import { BaseContainerModel } from "../base-container.model";
import { bl_wms_grn_processing_queue_RowInterface, bl_wms_grn_processing_queue_RowClass} from "../../dbschema/index";

export class WmsGrnProcessingQueueContainer extends BaseContainerModel {
    bl_wms_grn_processing_queue: bl_wms_grn_processing_queue_RowInterface = new bl_wms_grn_processing_queue_RowClass();
}
